@import '../../../globals/main.scss';

:root {
    --usp-preamble-margin: clamp(1.5rem, 3vw, 1.8rem);
}

pn-level-up {
    .pn-level-up {
        background: linear-gradient(90deg, $white 0%, $blue25 17.44%);
        color: $gray900;
        display: flex;
        flex-direction: column-reverse;
        max-width: 100%;
        padding: clamp(2rem, 5vw, 5rem);

        .heading {
            font-size: clamp(2rem, 4vw, 3rem);
            font-weight: 700;
            margin-bottom: 1rem;
        }

        .preamble {
            font-size: clamp(1rem, 4vw, 1.6rem);
            margin-top: var(--usp-preamble-margin);
            margin-bottom: var(--usp-preamble-margin);
        }

        .cta {
            display: flex;
            font-size: clamp(1rem, 4vw, 1.6rem);
            flex-direction: column;
            gap: clamp(1rem, 4vw, 1.2rem);
        }

        .image-container {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 2rem;

            .graphics {
                --pn-width: #{$graphicsWidth} !important;
                --pn-height: #{$graphicsWidth} !important;
            }

            .image {
                border-radius: 50%;
                width: 20rem;
                height: 20rem;
                object-fit: cover;
            }
        }

        @media (min-width: $min-width-md) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .content {
                max-width: 70%;
            }

            .cta {
                flex-direction: row;
                gap: clamp(2rem, 3vw, 3rem);
                padding: 0;
            }

            .image-container {
                margin-bottom: 0;

                .graphics {
                    --pn-width: #{$graphicsWidthMd};
                    --pn-height: #{$graphicsWidthMd};
                }
            }
        }

        @media (min-width: $min-width-xl) {
            max-width: $max-width-xl;
            margin: 0 auto;

            .image-container {
                .graphics {
                    --pn-width: #{$graphicsWidthXl};
                    --pn-height: #{$graphicsWidthXl};
                }
            }
        }

        @media (min-width: $min-width-xxl) {
            max-width: $max-width-xxl;

            .image-container {
                .graphics {
                    --pn-width: #{$graphicsWidthXxl};
                    --pn-height: #{$graphicsWidthXxl};
                }
            }
        }
    }
}